var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('sso-login')
        ko.components.register('sso-login', {
            viewModel: function (params) {
                var $this = this;
                var service = common.urlSearch(location.href)["service"];
                var accountName =common.urlSearch(location.href)["accountName"];
                var searchUrl = window.location.href.split("?")[1];

                if(searchUrl){
                    if (accountName){
                        common.redirectTo("/auth/sso/login/"+service+"?"+searchUrl);
                    }else {
                        common.redirectTo("/auth/sso/ssoLogin?"+searchUrl);
                    }
                }
            },
            template: require("./template/SSOLogin.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/sso/SSOLogin.js
// module id = 146
// module chunks = 0